module.exports = "<div class=\"main-content\">\r\n    <router-outlet></router-outlet>\r\n</div>    "